import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { bindPromiseCreators } from 'redux-saga-routines';

import { toJS } from '../../../utils/helper';

import JobsGrid from '../JobsGrid/index';
import { setJob } from '../../../redux/actions/jobs';
import { fetchJobsRoutine, removeJobPromise } from '../../../redux/routines';
import { showDialog, hideDialog, showConfirm } from '../../../redux/actions/dialogs';
import Dashboard from '../../Dashboard/index';
import CreateJobDialog from '../CreateJobDialog/index';
import { hasPermission } from '../../../utils/authenticated';
import { isDialogVisibleSelector } from '../../../redux/selectors';
import {
  JOB_DIALOG,
  CREATE_JOB_DIALOG
} from '../../../redux/constants/dialogs';

import styles from './styles';

// const generateCsv = (jobs) => {
//   const fields = ['id', 'reference', 'customer.name', 'primaryContact.name', 'start', 'end', 'origin.line1', 'origin.line2', 'origin.city', 'origin.state', 'origin.country', 'origin.postalCode', 'destination.line1', 'destination.line2', 'destination.city', 'destination.state', 'destination.country', 'destination.postalCode', 'profile.name', 'tasks.count', 'created.at', 'updated.at'];
//   const csv = json2csv({ data: jobs, fields });
//   const blob = new Blob([csv], { type: 'text/csv' });
//   FileSaver.saveAs(blob, 'jobs.csv');
// };
//
// const getSorter = (sorter = (a, b) => 0, order = 'asc') => {
//   return (a, b) => {
//     let result = sorter(a, b);
//
//     if (result === 0) {
//       result = sortDates(a.start, b.start);
//
//       if (result === 0) {
//         result = sortDates(a.end, b.end);
//
//         if (result === 0) {
//           result = sortStrings(a.id, b.id);
//         }
//       }
//     }
//
//     return result * getOrderDirection(order);
//   };
// };

// const getJobFilter = (filter) => {
//   return (job) => {
//     if (filter) {
//       if (job.reference && contains(job.reference, filter)) {
//         return true;
//       }
//       if (job.customer && contains(job.customer.name, filter)) {
//         return true;
//       }
//       if (job.primaryContact && contains(job.primaryContact.name, filter)) {
//         return true;
//       }
//       if (contains(job.description, filter)) {
//         return true;
//       }
//       // if (job.customer && contains(job.customer.name, filter)) {
//       //   return true;
//       // }
//
//       return false;
//     }
//
//     return true;
//   };
// };

class Jobs extends Component {
  static propTypes = {
    fetchJobs: PropTypes.func.isRequired,
    removeJob: PropTypes.func.isRequired,
    jobs: PropTypes.object,
    loading: PropTypes.bool,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {};

  componentWillMount() {
    this.setState({
      editable: hasPermission(['Administrator', 'JobCreator']),
      // data: this.props.jobs.sort(this.state.sortBy),
    });
  }

  handleCreateJobRequest = () => {
    this.props.showDialog(CREATE_JOB_DIALOG, { job: {} });
  };

  // handleFilterValueChange = (filter) => {
  //   const { jobs } = this.props;
  //   const { page, limit, sortBy } = this.state;
  //
  //   const data = jobs.filter(getJobFilter(filter ? filter.trim().toLowerCase() : '')).sort(sortBy);
  //   this.setState({
  //     page: Math.min(page, Math.floor(data.length / limit) + 1),
  //     data,
  //   });
  // };

  // handleSortOrderChange = (key, order) => {
  //   let sortBy = getSorter();
  //   switch (key) {
  //     case 'reference':
  //       sortBy = getSorter((a, b) => sortStrings(a.reference, b.reference), order);
  //       break;
  //     case 'customer':
  //       sortBy = getSorter((a, b) => sortStrings(a.customer ? a.customer.name : '', b.customer ? b.customer.name : ''), order);
  //       break;
  //     case 'primaryContact':
  //       sortBy = getSorter((a, b) => sortStrings(a.primaryContact ? a.primaryContact.name : '', b.primaryContact ? b.primaryContact.name : ''), order);
  //       break;
  //     case 'start':
  //       sortBy = getSorter((a, b) => sortDates(a.start, b.start), order);
  //       break;
  //     case 'end':
  //       sortBy = getSorter((a, b) => sortDates(a.end, b.end), order);
  //       break;
  //     case 'tasks':
  //       sortBy = getSorter((a, b) => {
  //         const aCount = (a && a.tasks && a.tasks.count) ? a.tasks.count : 0;
  //         const bCount = (b && b.tasks && b.tasks.count) ? b.tasks.count : 0;
  //
  //         return aCount - bCount;
  //       }, order);
  //       break;
  //     case 'created':
  //       console.log('order', order);
  //       sortBy = getSorter((a, b) => sortDates(a.created ? a.created.at : new Date(), b.created ? b.created.at : new Date()), order);
  //       break;
  //     default:
  //       break;
  //   }
  //
  //   this.setState({
  //     data: this.state.data.sort(sortBy),
  //     sortBy,
  //   });
  // };

  // handleMultiRemove = () => {
  //   if (this.state.selectedRows.length < 1) {
  //     return null;
  //   }
  //
  //   const { data, page, limit } = this.state;
  //   const currentData = data.slice((page - 1) * limit, page * limit);
  //   const jobs = currentData.filter((job, index) => {
  //     return ((this.state.selectedRows.map((val) => val)).includes(index));
  //   });
  //
  //   this.handleRemoveJobs(jobs);
  // };

  handleRemove = (job) => {
    return this.handleRemoveJobs([job]);
  };

  handleRemoveJobs = (jobs) => {
    return new Promise((resolve, reject) => {
      const message = `Are you sure you wish to remove the ${jobs.length > 1 ? jobs.length : ''} 
      selected ${jobs.length > 1 ? 'jobs' : 'job'}?`;
      this.props.showConfirm({
        title: message,
        onConfirm: () => {
          Promise.all(jobs.map((job) => this.props.removeJob(job)))
            .then(() => {
              console.log('jobs deleted');
              resolve();
            });
        },
        onReject: reject,
      });
    });
  };

  handleEdit = (job) => {
    this.props.showDialog(JOB_DIALOG, { job });
  };

  // handleExport = (evt, val) => {
  //   console.log('onExport', val);
  //   switch (val) {
  //     case 'export-current-page':
  //       generateCsv(this.state.data);
  //       break;
  //     case 'export-selected':
  //       generateCsv(_.at(this.state.data, this.state.selectedRows));
  //       break;
  //     case 'export-all':
  //     default:
  //       generateCsv(this.props.jobs);
  //       break;
  //   }
  // };

  render() {
    const { isDialogVisible, jobs, fetchJobs, showDialog } = this.props;
    const { editable } = this.state;

    return (
      <Dashboard title="Jobs">
        <div style={styles.wrapper}>
          <JobsGrid
            data={jobs}
            fetch={fetchJobs}
            onAdd={() => showDialog(CREATE_JOB_DIALOG, { job: {} })}
            onEdit={editable ? this.handleEdit : null}
            onRemove={editable ? this.handleRemove : null}
            showDialog={showDialog}
          />
        </div>

        {isDialogVisible(CREATE_JOB_DIALOG) ?
          <CreateJobDialog onClose={() => this.props.hideDialog(CREATE_JOB_DIALOG)}/> : null}

      </Dashboard>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchJobs: fetchJobsRoutine.trigger,
      setJob,

      showDialog,
      hideDialog,
      showConfirm,
    }, dispatch),
    ...bindPromiseCreators({
      removeJob: removeJobPromise,
    }, dispatch)
  };
}

function mapStateToProps(state) {
  return {
    jobs: toJS(state.getIn(['jobs', 'jobs'])),
    loading: state.getIn(['jobs', 'jobs', 'loading']),
    isDialogVisible: isDialogVisibleSelector(state),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Jobs);



// WEBPACK FOOTER //
// ./src/components/Jobs/JobsView/index.js